import React from 'react';

export const Menu = () => (
  <g>
    <path
      id="path54"
      fill="#71859b"
      strokeWidth="0.99999952"
      d="m 98.181819,932.72727 a 98.181818,98.181818 0 1 0 0,-196.36363 98.181818,98.181818 0 0 0 0,196.36363 z m 0,-294.54545 a 98.18182,98.18182 0 1 0 0,-196.36364 98.18182,98.18182 0 0 0 0,196.36364 z m 0,-294.54545 a 98.18182,98.18182 0 1 0 0,-196.36364 98.18182,98.18182 0 0 0 0,196.36364 z"
    />
    <path
      id="path66"
      fill="#7a8ca0"
      strokeWidth="0.99999952"
      d="M 294.54545,834.54546 H 1080 v 98.18181 H 294.54545 Z m 0,-294.54546 H 1080 v 98.18182 H 294.54545 Z m 0,-294.54545 H 1080 v 98.18182 H 294.54545 Z"
    />
  </g>
);
